export default {"src":"/_next/static/media/close_button_icon.8f3a27b6.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};